import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import "./../styles/Corporate.scss";
import "./../styles/Contact.scss";
import Api from "../common/api";

const Search = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const lang = localStorage.getItem("lang");
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[2]
  );

  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));

  
  const subWord = (string, wordCount = 41) => {
    if (string) {
      return string.split(" ").slice(0, wordCount).join(" ");
    } else {
      return "";
    }
  };

  React.useEffect(() => {
    Api.get("/home/search?searching=" + location.pathname.split("/")[2]).then(
      (res) => {
        setData(res.data);
      }
    );
  }, [location.pathname]);

  return (
    <>
      <header
        className="contact-header"
        style={{
          backgroundImage: `url("https://sankoenerji.com.tr/Uploads/MediaCenter/contactbg.4e91eb01.jpg")`,
        }}
      ></header>
      <div className="">
        <div className="corporate-content container-sm">
          <br />
          <br />
          {lang == "en" ? (
            <h2>Search results for"{location.pathname.split("/")[2]}"</h2>
          ):(
            <h2>"{location.pathname.split("/")[2]}" için arama sonuçları </h2>
          )}
          {data ? (

            lang == "en" ? (
              <ul className="search-list">
              {data.news
                ? 
                data.news.map((sub) => {
                    return (
                      sub.Title_EN ? (
                      <li key={sub.id}>
                        <Link to={"/en/media-center/our-news/" + sub.Slug}>
                          {sub.Title_EN}
                        </Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: subWord(sub.Content_EN),
                          }}
                        ></p>
                      </li>
                      ):""
                    );
                  })
                : null}

              {data.contents
                ? data.contents.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/en/content/" + sub.Slug_EN}>{sub.Title_EN}</Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: subWord(sub.Content_EN),
                          }}
                        ></p>
                      </li>
                    );
                  })
                : null}

              {data.centrals
                ? data.centrals.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/en/activities/electricity-production"}>{sub.Name_EN}</Link>
                      </li>
                    );
                  })
                : null}
            </ul>

            ):(
              <ul className="search-list">
              {data.news
                ? data.news.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/medya-merkezi/haberlerimiz/" + sub.Slug}>
                          {sub.Title}
                        </Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: subWord(sub.Content),
                          }}
                        ></p>
                      </li>
                    );
                  })
                : null}

              {data.contents
                ? data.contents.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/icerik/" + sub.Slug}>{sub.Title}</Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: subWord(sub.Content_TR ? sub.Content_TR : sub.Content),
                          }}
                        ></p>
                      </li>
                    );
                  })
                : null}

              {/*data.bods
                ? data.bods.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/icerik/" + sub.Slug}>{sub.Title}</Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: subWord(sub.Content_TR),
                          }}
                        ></p>
                      </li>
                    );
                  })
                : null*/}

              {data.centrals
                ? data.centrals.map((sub) => {
                    return (
                      <li key={sub.id}>
                        <Link to={"/faaliyet-alanlari/elektrik-uretimi"}>{sub.Name_TR}</Link>
                      </li>
                    );
                  })
                : null}
            </ul>
            )
     
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Search;
